import React from 'react';
import useTaskField from '@dyl/pages/Tasks/edit/useTaskField';
import { times } from 'lodash';
import { DragCanvasImage } from '@dyl/components/DragCanvas';
import { useImage } from '@dyl/systems/ImagesManager';

const itemTypeImageIdMappings = {
    PLACEMENT: 'placement_image_id',
    HIGHLIGHT: 'image_id',
    MESSAGE: 'image_id',
    /* Used by A1 Picture Editing to handle previous image drawing, not an actual item type */
    CHOICE: 'image_id'
}

export default function PreviousImages({ index }) {
    const [items] = useTaskField('items');


    return items.map(({ item_type }, i) => {
        if (i >= index || !(item_type in itemTypeImageIdMappings)) {
            return null;
        }

        return <ImagesOf key={i} index={i} item_type={item_type} />;
    });
}

function ImagesOf({ index, item_type }) {
    const [answers] = useTaskField('items', index, 'answers');

    return times(answers.length, answerIndex => (
        <AnswerImage
            key={answerIndex}
            itemIndex={index}
            index={answerIndex}
            item_type={item_type}
        />
    ));
}

function AnswerImage({ itemIndex, index, item_type }) {
    const [type] = useTaskField('items', itemIndex, 'item_type');
    const imageField = itemTypeImageIdMappings[type];

    const [imageId] = useTaskField('items', itemIndex, 'answers', item_type === 'CHOICE' ? 0 : index, imageField);
    const [coordinates] = useTaskField('items', itemIndex, 'answers', index, 'coordinates');

    const { src } = useImage(imageId);

    return (
        <DragCanvasImage
            src={src}
            alt={imageId}
            coordinates={coordinates}
            disabled
        />
    );
}